import { useQueryClient, useQuery } from 'react-query';
import { getPaymentMethod } from 'resources/company/company.api';

export default function usePaymentMethod(queryOptions) {
  const queryClient = useQueryClient();
  const currentUser = queryClient.getQueryData(['user.currentUser']);

  return useQuery(['company.paymentMethod', currentUser?.companyId],
    () => getPaymentMethod(),
    queryOptions,
  );
}
